import * as actions from 'actions';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.USER_AVATARS_FETCH: {
      return INITIAL_STATE;
    }

    case actions.USER_AVATARS_FETCH_SUCCESS: {
      return action.result.userAvatarIds;
    }

    default:
      return state;
  }
};




/** WEBPACK FOOTER **
 ** ./src/members/state/user/avatars/ids/reducer.js
 **/